import { FC } from "react";

import { PostTagI } from "@/interfaces/strapi/collection-types";
import { clsxMerge } from "shared/lib/helpers";

interface TagPropsI {
  className?: string;
  tag: PostTagI;
}

interface TagsPropsI {
  className?: string;
  tagClassName?: string;
  tags?: PostTagI[];
}

const Tag: FC<TagPropsI> = ({ className, tag }) => (
  <span
    className={clsxMerge(
      "rounded px-2 py-1",
      "bg-landing-pink-50 text-landing-pink-100 typography-body-4-medium",
      className
    )}
  >
    {tag.value}
  </span>
);

export const Tags: FC<TagsPropsI> = ({ className, tagClassName, tags }) => {
  if (!tags) {
    return null;
  }

  return (
    <div className={clsxMerge("flex flex-wrap gap-2", className)}>
      {tags.map((tag, idx) => (
        <Tag key={idx} className={tagClassName} tag={tag} />
      ))}
    </div>
  );
};
